import {SECTION_MAP} from '../../../../constants/section-mapping'
import {
  SECTION_CORPORTATE_REPRESENTATIVES,
  SECTION_DOCUMENTS,
  SECTION_INTERMEDIARY_SHAREHOLDERS,
  SECTION_OVERVIEW,
  SECTION_PAYMENT_INFORMATION,
  SECTION_REGISTRATION_NUMBERS,
  SECTION_SELLER_TRADE_PARTNERS,
} from '../../../../constants/sections'
import {selectInputFieldsBySectionName} from '../../../../modules/input-fields'

const MainNavigationOrder = [
  SECTION_OVERVIEW,
  SECTION_SELLER_TRADE_PARTNERS,
  SECTION_REGISTRATION_NUMBERS,
  SECTION_CORPORTATE_REPRESENTATIVES,
  SECTION_INTERMEDIARY_SHAREHOLDERS,
  SECTION_PAYMENT_INFORMATION,
  SECTION_DOCUMENTS,
]

const createNavStack = (sectionName: string): string[] => {
  if (SECTION_MAP[sectionName] === undefined) {
    return [sectionName]
  }
  const navItems: string[] = []
  const childNavItems = SECTION_MAP[sectionName]
  childNavItems.forEach(navItem => navItems.push(...createNavStack(navItem)))
  return navItems
}

// generating nav items stack for edge nav items(items with no child nav items) only since those
// are the pages that are shown and middle nav items don't have a specific page to go to
const edgeNavItemsStack: string[] = []
MainNavigationOrder.forEach(sectionName => {
  const navItems = createNavStack(sectionName)
  edgeNavItemsStack.push(...navItems)
})

export const getNextSection = (state: Record<string, any>, sectionName: string): string | null => {
  const currentSectionIndex = edgeNavItemsStack.findIndex(navItem => navItem === sectionName)
  let nextNavItems: string[] = []
  if (currentSectionIndex !== -1 && currentSectionIndex !== edgeNavItemsStack.length - 1) {
    nextNavItems = edgeNavItemsStack.slice(currentSectionIndex + 1)
  }
  // eslint-disable-next-line no-restricted-syntax
  for (const nextNavItem of nextNavItems) {
    if (selectInputFieldsBySectionName(state, nextNavItem).length > 0) {
      return nextNavItem
    }
  }
  return null
}
